export class LoggerMonitor {
  /* istanbul ignore next */
  onLog(log: any): void {
    console.log('message-from-logger', log);
  }
}
